<template>
  <div class="wrap">
    <header v-if="$route.query.from !='bs'">
      <img
        src="../assets/banner3.png"
        alt=""
      >
    </header>
    <div
      class="headline"
      v-if="$route.query.from !='bs'"
    >
      <p>运单查询</p>
      <span>Waybill query</span>
    </div>
    <div class="order">
      <div
        class="waybill"
        v-if="$route.query.from !='bs'"
      >
        <div>
          <textarea
            name=""
            id=""
            rows="10"
            placeholder="请输入您的订单号进行查询,订单号以回车符隔开"
            v-model="searchNumber"
          ></textarea>
          <button
            :class="btn?'active':''"
            type="button"
            @click="clickSearchBtn"
            v-bind:disabled="btn"
          >立即查询</button>
        </div>
        <p>运单查询</p>
      </div>
      <div class="track">
        <p v-if="findBillList.length === 0 && !btn">订单追踪......</p>
        <div
          class="pro"
          v-if="btn"
        >
          <img
            src="../assets/loading.gif"
            alt=""
          >
        </div>
        <div
          class="process"
          v-else
          v-for="(item,ind) in findBillList"
          :key="ind"
        >
          <div class="proces">
            <p>订单号：<span>{{item.number}}</span></p>
            <div class="logistics_name">
              <img
                src="../assets/icons1.png"
                alt=""
                v-if="item.expressalias && item.expressalias == 'EMS'"
              >
              <img
                src="../assets/icons.png"
                alt=""
                v-else-if="item.expressalias && item.expressalias == '顺丰速运'"
              >
              <p>转运单号：
                <span>{{item.expressno?item.expressno:'暂无转运单号'}}</span>
                <span v-if="item.expressno" class="copy-btn" v-clipboard:copy="item.expressno" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</span>
              </p>
            </div>
          </div>
          <div
            class="logistics"
            v-if="item.list.length"
          >
            <p v-if="item.flag">
              {{item.list[0].time}} {{item.list[0].remark}}
            </p>
            <p
              v-for="(zem,index) in item.list"
              :key="index"
              v-else
            >
              {{zem.time}} {{zem.remark}}
            </p>

          </div>
          <p
            @click="check(ind)"
            :value="ind"
            style="cursor:pointer"
            v-if="item.list.length"
          >{{item.view}}</p>
        </div>
      </div>
    </div>
    <tips :flag="tipsFlag"></tips>
  </div>

</template>
<script>
import { mapState } from 'vuex'
import tips from '../components/tips'
import { getRoutes, getSingleRoutes } from '@/services/billSearch'
export default {
  name: 'WaybillQuery',
  props: {},
  data() {
    return {
      searchNumber: '',
      flag: false,
      aer: false,
      findBillList: [],
    }
  },
  components: {
    tips
  },
  computed: {
    ...mapState({
      billNumber: state => state.value,
      btn: state => state.btn,
      tipsFlag: state => state.tipsFlag,
    })
  },
  methods: {
    // 复制成功时的回调函数
    onCopy (e) {
      this.$store.commit('setTipsFlag', { tips: '内容已复制到剪切板！', search_flag: true, tipsCode: 1 });
    },
    // 复制失败时的回调函数
    onError (e) {
      this.$store.commit('setTipsFlag', { tips: '抱歉，复制失败！', search_flag: true, tipsCode: 2 });
    },
    clickSearchBtn() {
      this.search(this.searchNumber)
    },
    search(bill) {
      var reg = /^[0-9a-zA-Z\n\s]+$/;
      if (bill != '' && !reg.test(bill)) {
        this.$store.commit('setTipsFlag', { tips: '请输入英文、数字、回车~~', search_flag: true, tipsCode: 2 });
        this.$store.commit('changeBtn', false);
        return
      }
      if (bill == '') {
        this.$store.commit('setTipsFlag', { tips: '您还没有输入您要查询的订单号~~', search_flag: true, tipsCode: 2 });
        this.$store.commit('changeBtn', false);
        return
      }
      var search_arr = bill.split("\n");
      var temp_arr = [];
      search_arr.forEach(item => {
        if (item) {
          temp_arr.push(item.trim());
        }
      });
      this.findBillList = []
      this.$store.commit('changeBtn', true);
      if (temp_arr.length == 1) {
        this.searchSingleBill(temp_arr[0])
      } else {
        this.searchBillMore(temp_arr);
      }

    },
    check(index) {
      if (this.findBillList[index].view == '暂无更多消息') {
        return;
      } else {
        if (this.findBillList[index].flag) {
          this.findBillList[index].flag = false;
          this.findBillList[index].view = '收起';
        } else {
          this.findBillList[index].flag = true;
          this.findBillList[index].view = '点击查看更多消息';
        }
      }
      this.$forceUpdate();
    },
    searchBillMore(payload) {
      getRoutes({ billIds: payload }).then(res => {
        this.$store.commit('changeBtn', false);
        if (res.code == '0000') {
          if (res.result.length === 0) {
            this.$store.commit('setTipsFlag', { tips: payload.join() + '均不存在', search_flag: true, tipsCode: 2 });
          } else {
            this.findBillList = res.result;
            this.findBillList.map(item => {
              item.flag = true;
              if (item.list.length === 1) {
                item.view = "暂无更多消息";
              } else {
                item.view = "点击查看更多消息";
              }
            });
            var resultBill = [];
            this.findBillList.forEach((item) => {
              resultBill.push(item.number)
            })
            if (this.getDiffrene(resultBill, payload).length) {
              this.$store.commit('setTipsFlag', { tips: this.getDiffrene(resultBill, payload).join() + ':Fastgo单号不存在', search_flag: true, tipsCode: 2 });
            }
          }
        } else {
          this.$store.commit('setTipsFlag', { tips: res.msg, search_flag: true, tipsCode: 2 });
        }
      }).catch((error) => {
        this.$store.commit('setTipsFlag', { tips: '请求失败', search_flag: true, tipsCode: 2 });
      })
    },
    searchSingleBill(bill_number) {
      var that = this;
      getSingleRoutes(bill_number).then(res => {
        that.$store.commit('changeBtn', false);
        if (res.code == '0000') {
          that.findBillList.push(res.result);
          if (this.$route.query.from == 'bs') {
            that.findBillList.map(item => {
              item.flag = false;
              item.list = that.sortdown(item.list);
              if (item.list.length === 1) {
                item.view = "暂无更多消息";
              } else {
                item.view = "收起";
              }
            });
          } else {
            that.findBillList.map(item => {
              item.flag = true;
              item.list = that.sortdown(item.list);
              // console.log(item.list)
              if (item.list.length === 1) {
                item.view = "暂无更多消息";
              } else {
                item.view = "点击查看更多消息";
              }
            });
          }
        } else {
          that.$store.commit('setTipsFlag', { tips: bill_number + ':' + res.msg, search_flag: true, tipsCode: 2 });
        }

      }).catch((error) => {
        this.$store.commit('setTipsFlag', { tips: '请求失败', search_flag: true, tipsCode: 2 });
      })
    },
    // 数组排序
    sortdown(arr) {
      if (!arr.length) {
        return arr;
      }
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = 0; j < arr.length - 1 - i; j++) {
          if (new Date(arr[j].time).getTime() < new Date(arr[j + 1].time).getTime()) {
            var temp = arr[j];
            arr[j] = arr[j + 1];
            arr[j + 1] = temp;
          }
        }
      }
      return arr;
    },
    getDiffrene(arr2, arr1) {
      let difference = arr1.filter(function (val) {
        return arr2.indexOf(val) == -1
      })
      return difference;
    }
  },
  mounted() {
    if (this.$route.query.from == 'bs') {
      this.$store.commit('changeValue', this.$route.query.bill)
    }
    if (this.billNumber) {
      this.searchNumber = this.billNumber
      this.search(this.billNumber)
    }
  }
}
</script>
<style scoped lang="scss">
.wrap {
  margin-bottom: 97px;
  .userLogin {
    min-width: 200px;
    height: 50px;
    background: #666;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -100px;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    img {
      width: 25px;
      height: 25px;
      margin-right: 15px;
    }
    p {
      font-size: 17px;
      color: #fff;
      font-weight: bold;
    }
  }
}

.headline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.order {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  .waybill {
    width: 260px;
    height: 398px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    margin-right: 38px;
    div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 328px;
      padding: 60px 25px;
      box-sizing: border-box;
      background: #4c4c4c;
      position: relative;
      textarea {
        width: 212px;
        height: 147px;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;
        border: 2px solid #dcdcdc;
        resize: none;
        outline: none;
      }
      button {
        width: 111px;
        height: 43px;
        border: none;
        border-radius: 10px;
        color: $bg-color;
        margin-top: 30px;
        background: #f6f6f6;
        font-size: 15px;
      }
      button.active {
        background: #999898;
      }
    }
    > p {
      width: 100%;
      height: 68px;
      background: $bg-color;
      color: #fff;
      line-height: 68px;
      box-sizing: border-box;
      font-size: 20px;
      text-align: center;
    }
  }
  .track {
    flex: 1;
    background: #eceaea;
    display: flex;
    flex-direction: column;
    padding: 10px;
    min-height: 400px;
    > p {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999898;
      font-weight: 700;
    }
    .pro {
      width: 100%;
      height: 378px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        /*height: 100px;*/
      }
    }
    .process {
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 10px;
      padding: 10px 0;
      margin-top: 10px;
      .proces {
        display: flex;
        height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        line-height: 50px;
        p {
          color: #626262;
          height: 50px;
          line-height: 50px;
          span {
            color: #000;
          }
        }
        .logistics_name {
          display: flex;
          align-items: center;
          img {
            height: 30px;
          }
          p {
            height: 30px;
            line-height: 30px;
            min-width: 250px;
            color: #fff;
            background: #000;
            border-radius: 5px;
            padding: 0 10px;
            margin-left: 8px;
            text-align: center;
            span {
              color: #fff;
            }
          }
        }
      }
      .logistics {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        box-sizing: border-box;
        border-top: 1px solid #999898;
        p {
          line-height: 30px;
          border-bottom: 1px dotted #000;
        }
      }
      > p {
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
        box-sizing: border-box;
        text-align: right;
        border: none;
        background: #fff;
      }
    }
    .ar {
      width: 100%;
      height: 378px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/WaybillQuery.vue